<template>
  <div class="cert-guide app-container">
    <!--认证前选择服务-->
    <div class="card flex-1">
      <div class="guide-header">精彩纵横云采购平台适用引导</div>
      <div class="guide-header-tip">
        为了您可以尽快参与或发布采购项目，请按照下方引导流程进行操作
      </div>

      <!--服务选择卡片-->
      <div class="service-card-wrapper flex row-center">
        <div
          v-for="service in platformServiceDict.dictArray"
          :key="service.alias"
          class="service-card flex flex-col"
          :class="{ active: currentService === service.alias }"
          @click="currentService = service.alias"
        >
          <div
            class="selected-tag flex row-center col-center"
            :class="{ active: currentService === service.alias }"
          >
            <el-icon class="el-icon-check" />
          </div>

          <img
            :src="require(`@/assets/images/common/service/${service.alias}-icon.png`)"
            alt=""
          />
          <div class="service-card-label">{{ service.label }}</div>
          <div class="service-card-desc m-t-12">{{ service.desc }}</div>
        </div>
      </div>

      <!--确定按钮-->
      <div class="m-t-48 flex row-center">
        <el-button
          plain
          class="cert-btn"
          @click="giveUpCertification"
        >暂不认证</el-button>
        <el-button
          type="primary"
          class="cert-btn"
          :disabled="!currentService"
          @click="goToCertification"
        >开始认证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 数据字典
import { platformServiceDict } from '@/dictionary/company'

export default {
  name: 'SelectService',

  beforeRouteEnter(to, form, next) {
    const isNew = to.params.new
    if (isNew && isNew !== 'new') {
      // TODO: 后期是否要增加404页面
      return next({ name: 'Login' })
    }
    next()
  },

  data() {
    return {
      // 数据字典
      platformServiceDict,

      // 路由参数
      isNew: this.$route.params.new,

      // 当前选中的服务
      currentService: '',

      //
      returnUrl: this.$route.query.returnUrl
    }
  },

  methods: {
    goToCertification() {
      if (!this.currentService) {
        this.$message.warning('请先选择需要开通的身份')
        return
      }

      this.$router.replace({
        name: 'CertForm',
        params: { service: this.currentService, new: this.isNew }
      })
    },

    // 暂不认证
    giveUpCertification() {
      if (this.returnUrl) {
        window.location.href = this.returnUrl
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cert-guide {
  width: 1200px;
  margin: 0 auto;

  .guide-header {
    margin-top: 32px;
    font-size: 20px;
    @include text-bold;
    text-align: center;
  }

  .guide-header-tip {
    margin-top: 8px;
    text-align: center;
    color: $text-second-color;
  }

  //服务卡片样式
  .service-card-wrapper {
    margin-top: 48px;

    .service-card {
      position: relative;
      width: 260px;
      height: 320px;
      border: 1px solid $info-third-color;
      border-radius: 4px;
      transition: transform 0.3s ease-in-out;
      margin: 0 8px;

      &:hover,
      &.active {
        border-color: $primary-color;
        transform: translateY(-12px);
      }

      img {
        width: 140px;
        height: auto;
        margin-top: 60px;
      }

      .selected-tag {
        position: absolute;
        top: 18px;
        right: 24px;
        width: 22px;
        height: 22px;
        border: 1px solid $info-third-color;
        color: transparent;
        border-radius: 50%;

        &.active {
          border-color: $primary-color;
          background-color: $primary-color;
          color: $white-color;
        }
      }

      .service-card-label {
        margin-top: 40px;
        @include text-bold;
      }
      .service-card-desc {
        font-size: 12px;
        color: $text-third-color;
      }
    }
  }

  // 认证按钮
  .cert-btn {
    width: 160px;
  }
}
</style>
